import { css } from '@emotion/css'
import { useEffect, useMemo, useState } from 'react'
import { usePagination, useSortBy, useTable } from 'react-table'
import Swal from 'sweetalert2'
import { useCustomReducer } from '../../../../../base/customHooks'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { translate } from '../../../../../base/localization'
import { exportToXLSX } from '../../../../../base/utils/dataHelper'
import InputCampaign from '../../../../../components/InputCampaign'
import IPCheckbox from '../../../../../components/IPCheckBox'
import IPInput from '../../../../../components/IPInput'
import IPRadio from '../../../../../components/IPRadio'
import IPSelectBox from '../../../../../components/IPSelectBox'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import Translations from '../../../../../translations'
import { getCompanyApi } from '../../../components/api'
import { PaymentTransactionList, PaymentTransactionListRequest, PaymentTransactionListResponse } from '../models/model'
import { PaymentTransactionApi } from '../services/getBankInstallmentReportListApi'
import './style.scss'
interface BankInstallmentReportListState {
  reportList: PaymentTransactionListResponse
  form: PaymentTransactionListRequest
  Company: ISelectOption | null
  companyListOptions: ISelectOption[]
  companyListOption: any
}

function BankInstallmentReport(props: BaseComponentWithContextProps) {
  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  inititalStartDate.setHours(0)
  inititalStartDate.setMinutes(0)
  inititalStartDate.setSeconds(0)
  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState(new Date())
  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(' ', 'T')
  }

  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  const getInitialState = (): BankInstallmentReportListState => {
    return {
      reportList: {
        Id: 0,
        PaymentTransactionLists: [],
        TotalKalanLimit: 0.0,
        TotalKullanilanBakiye: 0.0,
        TotalOdemeAltiTaksit: 0.0,
        TotalOdemeBesTaksit: 0.0,
        TotalOdemeDokuzTaksit: 0.0,
        TotalOdemeDortTaksit: 0.0,
        TotalOdemeIkiTaksit: 0.0,
        TotalOdemeOnBesTaksit: 0.0,
        TotalOdemeOnIkiTaksit: 0.0,
        TotalOdemeOnSekizTaksit: 0.0,
        TotalOdemePesin: 0.0,
        TotalOdemeUcTaksit: 0.0,
        TotalOdemeYirmiDortTaksit: 0.0,
        TotalPosLimit: 0.0,
      },
      form: {
        StartDate: inititalStartDate,
        EndDate: new Date(),
        Durumu: 2,
        IslemTipi: 1,
        AitOlduguDonem: '',
        DealerCode: '',
        KanalSorumlusu: '',
        FirmaTipi: '',
        Company: 0,
        IsBankGroup: false,
      },
      Company: null,
      companyListOption: null,
      companyListOptions: [
      ],
    }
  }

  const initialState = getInitialState()
  const [state, setState] = useCustomReducer<BankInstallmentReportListState>(initialState)
  const t = translate(Translations)
  const [companyOptions, setCompanyOptions] = useState<ISelectOption[]>([])
  const [filteredList, setFilteredList] = useState<PaymentTransactionList[]>([])
  const [totalCol, setTotalCol] = useState<PaymentTransactionListResponse>()
  const [showFilterRow, setShowFilterRow] = useState(false)
  const [campaignSelectOptions, setCampaignSelectOptions] = useState<ISelectOption[]>([])
  const [campaignSelectOption, setCampaignSelectOption] = useState<ISelectOption[]>([])
  const [bankSelectOptions, setBankSelectOptions] = useState<ISelectOption[]>([])
  const [bankSelectOption, setBankSelectOption] = useState<any>()
  const [dealerFilter, setDealerFilter] = useState('')
  const [isBankGroup, setIsBankGroup] = useState<boolean>(false)
  const [showBankNameColumn, setShowBankNameColumn] = useState<boolean>(isBankGroup)

  const toggleBankNameColumn = () => {
    setShowBankNameColumn(!showBankNameColumn)
  }

  const getCompanies = async () => {
    const res: any[] = await getCompanyApi()
    const companies = res.map(x => ({ label: x.Name, value: x.Code }))
    setState({ companyListOptions: companies })
    setCompanyOptions(companies)
  }

  useEffect(() => {
    getCompanies()
  }, [])

  const dateToISO = date => new Date(new Date(date).getTime() + 3 * 3600 * 1000)

  const dateToEndOfDayISO = date => {
    const endOfDay = new Date(date)
    endOfDay.setHours(26, 59, 59, 999) // Set hours, minutes, seconds, and milliseconds to the end of the day
    return endOfDay
  }

  const dateValid = () => {
    const result = state.form.EndDate.getTime() - state.form.StartDate.getTime()
    if (result < 60000) {
      Swal.fire('Bitiş tarihi başlangıç tarihinden önce olamaz.')
      setState({ form: { ...state.form, EndDate: new Date() } })
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    // Reset state values
    setCampaignSelectOption([])
    setBankSelectOption(null)
    setState({ companyListOption: null })
    setDealerFilter('')

    const req = {
      ...state.form,
      StartDate: dateToISO(startDate),
      EndDate: dateToEndOfDayISO(endDate),
      Company: state.Company === null ? 0 : (state.Company.value as number),
      IsBankGroup: isBankGroup,
    }

    try {
      props.showLoading()
      const res = await new PaymentTransactionApi({}).PaymentTransaction(req)
      props.hideLoading()

      if (res) {
        const uniqueBankLabels = {}
        const uniqueTermsLabels = {}

        // Extract options for CampaignSelect and BankSelect if isBankGroup is true
        const campaignOptions = res.PaymentTransactionLists.map(x => ({
          value: x.LimitTermsName,
          label: x.LimitTermsName.toUpperCase(),
        }))
        setCampaignSelectOptions(
          campaignOptions.filter(option => {
            if (!uniqueTermsLabels[option.label]) {
              uniqueTermsLabels[option.label] = true
              return true
            }
            return false
          })
        )

        if (isBankGroup) {
          const bankOptions = res.PaymentTransactionLists.map(x => ({
            value: x.BankName,
            label: x.BankName.toUpperCase(),
          }))
          setBankSelectOptions(
            bankOptions.filter(option => {
              if (!uniqueBankLabels[option.label]) {
                uniqueBankLabels[option.label] = true
                return true
              }
              return false
            })
          )
        }

        setState({ reportList: res })
        setTotalCol(res)
        setFilteredList(res.PaymentTransactionLists)
        setShowFilterRow(true)
        return
      }

      setState({ reportList: res })
    } catch (err: any) {
      props.hideLoading()
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  //#region Excel Export
  const excelButton = async () => {
    try {
      if (!filteredList || filteredList.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Excele atılacak veri bulunmamaktadır.',
          allowOutsideClick: true,
          backdrop: true,
        })
        return
      }

      const data = filteredList.map(p => {
        const rowData = {
          Şirket: companyOptions.length > 0 ? companyOptions.find(x => +x.value === p.Company)?.label || '' : '',
          'Hesap (SAP) Kodu': p.SapCode.replace('0000', ''),
          'Kampanya Adı': p.LimitTermsName,
          'Bayi Adı': p.DealerName,
          Şehir: p.City,
          MT: p.MusteriTemsilcisi,
          KS: p.KanalTemsilcisi,
          'Firma Tipi': p.FirmaTipi,
          Dönemi: p.Donemi,
          Durumu: p.Durumu ? 'Aktif' : 'Pasif',
          'Pos Limit': +p.PosLimit,
          'Kullanılan Bakiye': +p.KullanilanBakiye,
          'Kalan Limit': +p.KalanLimit,
          Peşin: p.OdemePesin,
          '2 Taksit': p.OdemeIkiTaksit,
          '3 Taksit': p.OdemeUcTaksit,
          '4 Taksit': p.OdemeDortTaksit,
          '5 Taksit': p.OdemeBesTaksit,
          '6 Taksit': p.OdemeAltiTaksit,
          '9 Taksit': p.OdemeDokuzTaksit,
          '12 Taksit': p.OdemeOnIkiTaksit,
          '15 Taksit': p.OdemeOnBesTaksit,
          '18 Taksit': p.OdemeOnSekizTaksit,
          '24 Taksit': p.OdemeYirmiDortTaksit,
          'Sipariş Numarası': p.OrderNumber
        }

        if (isBankGroup) {
          rowData['Banka Adı'] = p.BankName
        }

        return rowData
      })

      exportToXLSX(data, 'İşlem Listesi')
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }
  //#endregion

  const handleChange = (e, val: string) => {
    setState({ form: { ...state.form, [val]: e.target.value } })
  }

  const handleSelectChange = (option: ISelectOption, val: string) => {
    setState({ form: { ...state.form, [val]: option ? option.value : null }, [val]: option })
  }

  //#region Detaylı Süzme fonksiyonu
  const filterList = () => {
    const filterConditions: ((item: PaymentTransactionList) => boolean)[] = []

    if (campaignSelectOption.length > 0) {
      filterConditions.push(b => {
        const selectedLabels = campaignSelectOption.map(option => option.label.toUpperCase())
        return selectedLabels.includes(b.LimitTermsName.toUpperCase())
      })
    }

    if (bankSelectOption) {
      filterConditions.push(b => b.BankName.toUpperCase() === bankSelectOption.label)
    }

    if (dealerFilter) {
      filterConditions.push(b => b.SapCode.includes(dealerFilter))
    }
    if (state.companyListOption) {
      filterConditions.push(c => c.Company === state.companyListOption.value)
    }

    let filteredData: PaymentTransactionList[] = state.reportList.PaymentTransactionLists

    if (filterConditions.length > 0) {
      filteredData = filteredData.filter(item => {
        return filterConditions.every(condition => condition(item))
      })
    }
    setFilteredList(filteredData)
  }
  //#endregion

  const columns = useMemo(() => {
    const currencyColumn = {
      Cell: ({ value }) => {
        if (typeof value === 'number') {
          return value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺'
        }
        return value
      },
    }
    const baseColumns = [
      {
        Header: 'Şirket',
        accessor: 'Company',
      },
      {
        Header: 'SAP Kodu',
        accessor: 'SapCode',
      },
      {
        Header: 'Kampanya Adı',
        accessor: 'LimitTermsName',
      },
      {
        Header: 'Hesap Adı',
        accessor: 'DealerName',
      },
      {
        Header: 'Şehir',
        accessor: 'City',
      },
      {
        Header: 'MT',
        accessor: 'MT',
      },
      {
        Header: 'KS',
        accessor: 'KS',
      },
      {
        Header: 'Firma Tipi',
        accessor: 'FirmaTipi',
      },
      {
        Header: 'Dönem',
        accessor: 'Donemi',
      },
      {
        Header: 'Durum',
        accessor: 'Durumu',
      },
      {
        Header: 'POS Limiti',
        accessor: 'PosLimit',
        ...currencyColumn,
      },
      {
        Header: 'Kullanılan',
        accessor: 'KullanilanBakiye',
        ...currencyColumn,
      },
      {
        Header: 'Kalan Limiti',
        accessor: 'KalanLimit',
        ...currencyColumn,
      },
      {
        Header: 'Peşin',
        accessor: 'OdemePesin',
        ...currencyColumn,
      },
      {
        Header: '2 Taksit',
        accessor: 'OdemeIkiTaksit',
        ...currencyColumn,
      },
      {
        Header: '3 Taksit',
        accessor: 'OdemeUcTaksit',
        ...currencyColumn,
      },
      {
        Header: '4 Taksit',
        accessor: 'OdemeDortTaksit',
        ...currencyColumn,
      },
      {
        Header: '5 Taksit',
        accessor: 'OdemeBesTaksit',
        ...currencyColumn,
      },
      {
        Header: '6 Taksit',
        accessor: 'OdemeAltiTaksit',
        ...currencyColumn,
      },
      {
        Header: '9 Taksit',
        accessor: 'OdemeDokuzTaksit',
        ...currencyColumn,
      },
      {
        Header: '12 Taksit',
        accessor: 'OdemeOnIkiTaksit',
        ...currencyColumn,
      },
      {
        Header: '15 Taksit',
        accessor: 'OdemeOnBesTaksit',
        ...currencyColumn,
      },
      {
        Header: '18 Taksit',
        accessor: 'OdemeOnSekizTaksit',
        ...currencyColumn,
      },
      {
        Header: '24 Taksit',
        accessor: 'OdemeYirmiDortTaksit',
        ...currencyColumn,
      },
      {
        Header: 'Sipariş Numarası',
        accessor: 'OrderNumber',
      },
    ]

    if (isBankGroup) {
      baseColumns.splice(2, 0, {
        Header: 'Banka Adı',
        accessor: 'BankName',
      })
    }

    return baseColumns
  }, [isBankGroup])

  const data = useMemo(
    () =>
      filteredList.map(p => ({
        Company: companyOptions.length > 0 ? (companyOptions.find(x => +x.value === p.Company)?.label as string) : '',
        SapCode: p.SapCode.slice(4),
        BankName: p.BankName,
        LimitTermsName: p.LimitTermsName,
        DealerName: p.DealerName,
        City: p.City,
        MT: p.MusteriTemsilcisi,
        KS: p.KanalTemsilcisi,
        FirmaTipi: p.FirmaTipi,
        Donemi: p.Donemi,
        Durumu: p.Durumu ? 'Aktif' : 'Pasif',
        PosLimit: p.PosLimit ? +p.PosLimit : 0,
        KullanilanBakiye: p.KullanilanBakiye ? +p.KullanilanBakiye : 0,
        KalanLimit: p.KalanLimit ? +p.KalanLimit : 0,
        OdemeAltiTaksit: p.OdemeAltiTaksit ? +p.OdemeAltiTaksit : 0,
        OdemeBesTaksit: p.OdemeBesTaksit ? +p.OdemeBesTaksit : 0,
        OdemeDokuzTaksit: p.OdemeDokuzTaksit ? +p.OdemeDokuzTaksit : 0,
        OdemeDortTaksit: p.OdemeDortTaksit ? +p.OdemeDortTaksit : 0,
        OdemeIkiTaksit: p.OdemeIkiTaksit ? +p.OdemeIkiTaksit : 0,
        OdemeOnBesTaksit: p.OdemeOnBesTaksit ? +p.OdemeOnBesTaksit : 0,
        OdemeOnIkiTaksit: p.OdemeOnIkiTaksit ? +p.OdemeOnIkiTaksit : 0,
        OdemeOnSekizTaksit: p.OdemeOnSekizTaksit ? +p.OdemeOnSekizTaksit : 0,
        OdemePesin: p.OdemePesin ? +p.OdemePesin : 0,
        OdemeUcTaksit: p.OdemeUcTaksit ? +p.OdemeUcTaksit : 0,
        OdemeYirmiDortTaksit: p.OdemeYirmiDortTaksit ? +p.OdemeYirmiDortTaksit : 0,
        OrderNumber: p.OrderNumber
      })),
    [filteredList]
  )

  const formattedData = filteredList.map(p => ({
    PosLimit: p.PosLimit ? +p.PosLimit : 0,
    KullanilanBakiye: p.KullanilanBakiye ? +p.KullanilanBakiye : 0,
    KalanLimit: p.KalanLimit ? +p.KalanLimit : 0,
    OdemeAltiTaksit: p.OdemeAltiTaksit ? +p.OdemeAltiTaksit : 0,
    OdemeBesTaksit: p.OdemeBesTaksit ? +p.OdemeBesTaksit : 0,
    OdemeDokuzTaksit: p.OdemeDokuzTaksit ? +p.OdemeDokuzTaksit : 0,
    OdemeDortTaksit: p.OdemeDortTaksit ? +p.OdemeDortTaksit : 0,
    OdemeIkiTaksit: p.OdemeIkiTaksit ? +p.OdemeIkiTaksit : 0,
    OdemeOnBesTaksit: p.OdemeOnBesTaksit ? +p.OdemeOnBesTaksit : 0,
    OdemeOnIkiTaksit: p.OdemeOnIkiTaksit ? +p.OdemeOnIkiTaksit : 0,
    OdemeOnSekizTaksit: p.OdemeOnSekizTaksit ? +p.OdemeOnSekizTaksit : 0,
    OdemePesin: p.OdemePesin ? +p.OdemePesin : 0,
    OdemeUcTaksit: p.OdemeUcTaksit ? +p.OdemeUcTaksit : 0,
    OdemeYirmiDortTaksit: p.OdemeYirmiDortTaksit ? +p.OdemeYirmiDortTaksit : 0,
  }))

  const totalFields = [
    'PosLimit',
    'KullanilanBakiye',
    'KalanLimit',
    'OdemePesin',
    'OdemeIkiTaksit',
    'OdemeUcTaksit',
    'OdemeDortTaksit',
    'OdemeBesTaksit',
    'OdemeAltiTaksit',
    'OdemeDokuzTaksit',
    'OdemeOnIkiTaksit',
    'OdemeOnBesTaksit',
    'OdemeOnSekizTaksit',
    'OdemeYirmiDortTaksit',
  ]

  const totalValues = totalFields.map(field => formattedData.reduce((acc, p) => acc + +p[field], 0))

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    // @ts-ignore
    page,
    // @ts-ignore
    canPreviousPage,
    // @ts-ignore
    canNextPage,
    // @ts-ignore
    pageOptions,
    // @ts-ignore
    pageCount,
    // @ts-ignore
    gotoPage,
    // @ts-ignore
    nextPage,
    // @ts-ignore
    previousPage,
    // @ts-ignore
    setPageSize,
    // @ts-ignore
    state: { pageIndex, pageSize },
  } = useTable(
    {
      // @ts-ignore
      columns,
      data,
      // defaultColumn,
      // @ts-ignore
      initialState: { pageIndex: 0 },
    },
    useSortBy,
    usePagination
    // useBlockLayout
  )

  useEffect(() => {
    const pageSize = sessionStorage.getItem('PageSize')
    if (!pageSize) return
    setPageSize(pageSize)
  }, [])

  const tableStyles = css`
    tbody {
      border-top: none !important;
    }
    td {
      padding: 0.3rem 9px !important;
    }

    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `
  return (
    <div
      className='container-fluid'
      style={{
        // background: 'linear-gradient(135deg, #ec1d25 0%, #d41428 100%)',
        minHeight: '100vh',
        padding: '20px',
      }}
    >
      <div
        style={{
          maxWidth: '95%',
          margin: '0 auto',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderRadius: '20px',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            background: 'linear-gradient(135deg, #ec1d25, #d41428)',
            padding: '30px',
            color: 'white',
            position: 'relative',
          }}
        >
          <h1
            style={{
              fontSize: '2.5rem',
              fontWeight: '300',
              marginBottom: '10px',
              margin: 0,
            }}
          >
            {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.header')}
          </h1>
          <p
            style={{
              opacity: '0.9',
              fontSize: '1.1rem',
              margin: '10px 0 0 0',
              color: 'white',
            }}
          >
            {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.subHeader')}
          </p>
          <button
            type='button'
            style={{
              position: 'absolute',
              top: '30px',
              right: '30px',
              background: 'rgba(255, 255, 255, 0.2)',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
            onClick={excelButton}
            onMouseEnter={e => {
              const target = e.target as HTMLButtonElement
              target.style.background = 'rgba(255, 255, 255, 0.3)'
              target.style.transform = 'translateY(-2px)'
            }}
            onMouseLeave={e => {
              const target = e.target as HTMLButtonElement
              target.style.background = 'rgba(255, 255, 255, 0.2)'
              target.style.transform = 'translateY(0)'
            }}
          >
            📊 Excel
          </button>
        </div>
        <div
          style={{
            padding: '30px',
            background: '#f8f9fa',
            borderBottom: '1px solid #e9ecef',
          }}
        >
          <form id='id1' className='formform' onSubmit={handleSubmit}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '20px',
                marginBottom: '20px',
              }}
            >
              <div
                style={{
                  background: 'white',
                  padding: '20px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                }}
              >
                <h3
                  style={{
                    fontSize: '0.9rem',
                    color: '#495057',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    fontWeight: '600',
                  }}
                >
                  {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.status')}
                </h3>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      transition: 'all 0.2s ease',
                      background: state.form.Durumu === 1 ? 'linear-gradient(135deg, #ec1d25, #d41428)' : 'transparent',
                      color: state.form.Durumu === 1 ? 'white' : 'inherit',
                    }}
                    onClick={() => setState({ form: { ...state.form, Durumu: 1 } })}
                  >
                    <IPRadio
                      text=''
                      name='durumu'
                      onChange={() => setState({ form: { ...state.form, Durumu: 1 } })}
                      checked={state.form.Durumu === 1}
                    />
                    <span
                      className={`status-indicator status-active ${state.form.Durumu === 1 ? '' : ''}`}
                      style={{
                        background: state.form.Durumu === 1 ? 'rgba(255, 255, 255, 0.2)' : '#d4edda',
                        color: state.form.Durumu === 1 ? 'white' : '#155724',
                        marginLeft: '8px',
                      }}
                    >
                      {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.active')}
                    </span>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      transition: 'all 0.2s ease',
                      background: state.form.Durumu === 0 ? 'linear-gradient(135deg, #f56565, #e53e3e)' : 'transparent',
                      color: state.form.Durumu === 0 ? 'white' : 'inherit',
                    }}
                    onClick={() => setState({ form: { ...state.form, Durumu: 0 } })}
                  >
                    <IPRadio
                      text=''
                      name='durumu'
                      onChange={() => setState({ form: { ...state.form, Durumu: 0 } })}
                      checked={state.form.Durumu === 0}
                    />
                    <span
                      className={`status-indicator status-passive ${state.form.Durumu === 0 ? '' : ''}`}
                      style={{
                        background: state.form.Durumu === 0 ? 'rgba(255, 255, 255, 0.2)' : '#f8d7da',
                        color: state.form.Durumu === 0 ? 'white' : '#721c24',
                        marginLeft: '8px',
                      }}
                    >
                      {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.passive')}
                    </span>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      transition: 'all 0.2s ease',
                      background: state.form.Durumu === 2 ? 'linear-gradient(135deg, #ff6b35, #f7931e)' : 'transparent',
                      color: state.form.Durumu === 2 ? 'white' : 'inherit',
                    }}
                    onClick={() => setState({ form: { ...state.form, Durumu: 2 } })}
                  >
                    <IPRadio
                      text=''
                      name='durumu'
                      onChange={() => setState({ form: { ...state.form, Durumu: 2 } })}
                      checked={state.form.Durumu === 2}
                    />
                    <span
                      className={`status-indicator status-all ${state.form.Durumu === 2 ? '' : ''}`}
                      style={{
                        background: state.form.Durumu === 2 ? 'rgba(255, 255, 255, 0.2)' : '#fff3cd',
                        color: state.form.Durumu === 2 ? 'white' : '#856404',
                        marginLeft: '8px',
                      }}
                    >
                      {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.all')}
                    </span>
                  </div>
                </div>
              </div>

              {/* İşlem Tipi */}
              <div
                style={{
                  background: 'white',
                  padding: '20px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                }}
              >
                <h3
                  style={{
                    fontSize: '0.9rem',
                    color: '#495057',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    fontWeight: '600',
                  }}
                >
                  {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.processType')}
                </h3>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      transition: 'all 0.2s ease',
                      background:
                        state.form.IslemTipi === 1 ? 'linear-gradient(135deg, #ec1d25, #d41428)' : 'transparent',
                      color: state.form.IslemTipi === 1 ? 'white' : 'inherit',
                    }}
                    onClick={() => setState({ form: { ...state.form, IslemTipi: 1 } })}
                  >
                    <IPRadio
                      text={'Avantaj POS'}
                      name='islemtipi'
                      onChange={() => setState({ form: { ...state.form, IslemTipi: 1 } })}
                      checked={state.form.IslemTipi === 1}
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      transition: 'all 0.2s ease',
                      background:
                        state.form.IslemTipi === 2 ? 'linear-gradient(135deg, #e74c3c, #c0392b)' : 'transparent',
                      color: state.form.IslemTipi === 2 ? 'white' : 'inherit',
                    }}
                    onClick={() => setState({ form: { ...state.form, IslemTipi: 2 } })}
                  >
                    <IPRadio
                      text={t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.opportunity')}
                      name='islemtipi'
                      onChange={() => setState({ form: { ...state.form, IslemTipi: 2 } })}
                      checked={state.form.IslemTipi === 2}
                    />
                  </div>
                </div>
              </div>

              {/* Tarih Aralığı */}
              <div
                style={{
                  background: 'white',
                  padding: '20px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                }}
              >
                <h3
                  style={{
                    fontSize: '0.9rem',
                    color: '#495057',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    fontWeight: '600',
                  }}
                >
                  Tarih Aralığı
                </h3>
                <div style={{ marginBottom: '15px' }}>
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '5px',
                      fontWeight: '600',
                      color: '#495057',
                      fontSize: '14px',
                    }}
                  >
                    {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.period')}
                  </label>
                  <IPInput
                    type='text'
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '14px',
                      transition: 'all 0.2s ease',
                      background: 'white',
                    }}
                    id='AitOlduguDonem'
                    placeholder={t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.null')}
                    value={state.form.AitOlduguDonem}
                    onChange={e => setState({ form: { ...state.form, AitOlduguDonem: e.target.value } })}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '15px',
                  }}
                >
                  <div>
                    <InputCampaign
                      type='date'
                      id='StartDate'
                      name='StartDate'
                      label={'Başlangıç Tarihi'}
                      value={toDateTimeLocal(startDate)}
                      onChange={e => getDate(e.target.value, 'Start')}
                      isActive
                    />
                  </div>
                  <div>
                    <InputCampaign
                      type='date'
                      id='EndDate'
                      name='EndDate'
                      label={'Bitiş Tarihi'}
                      value={toDateTimeLocal(endDate)}
                      onChange={e => getDate(e.target.value, 'End')}
                      isActive
                    />
                  </div>
                </div>
              </div>

              {/* Arama Kriterleri */}
              <div
                style={{
                  background: 'white',
                  padding: '20px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                }}
              >
                <h3
                  style={{
                    fontSize: '0.9rem',
                    color: '#495057',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    fontWeight: '600',
                  }}
                >
                  Arama Kriterleri
                </h3>
                <div style={{ color: 'red', fontSize: '12px', marginBottom: '15px' }}>
                  *Birden çok filtre için boşluk bırakınız. Kullandığınız bütün filtreler için toplam sonucu getirir.
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '5px',
                      fontWeight: '600',
                      color: '#495057',
                      fontSize: '14px',
                    }}
                  >
                    {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.code')}
                  </label>
                  <IPInput
                    type='text'
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '14px',
                      transition: 'all 0.2s ease',
                      background: 'white',
                    }}
                    id='SiparisKodu'
                    placeholder={t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.null')}
                    value={state.form.DealerCode}
                    onChange={e => handleChange(e, 'DealerCode')}
                  />
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '5px',
                      fontWeight: '600',
                      color: '#495057',
                      fontSize: '14px',
                    }}
                  >
                    {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.channelManager')}
                  </label>
                  <IPInput
                    type='text'
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '14px',
                      transition: 'all 0.2s ease',
                      background: 'white',
                    }}
                    placeholder={t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.null')}
                    value={state.form.KanalSorumlusu}
                    onChange={e => handleChange(e, 'KanalSorumlusu')}
                  />
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '5px',
                      fontWeight: '600',
                      color: '#495057',
                      fontSize: '14px',
                    }}
                  >
                    {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.type')}
                  </label>
                  <IPInput
                    type='text'
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '14px',
                      transition: 'all 0.2s ease',
                      background: 'white',
                    }}
                    placeholder={t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.null')}
                    value={state.form.FirmaTipi}
                    onChange={e => handleChange(e, 'FirmaTipi')}
                  />
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '5px',
                      fontWeight: '600',
                      color: '#495057',
                      fontSize: '14px',
                    }}
                  >
                    Şirket
                  </label>
                  <IPSelectBox
                    isClearable
                    options={companyOptions}
                    value={state.Company}
                    onChangeSingle={option => handleSelectChange(option, 'Company')}
                  />
                </div>
              </div>
            </div>

            {/* Actions Row */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '20px',
                flexWrap: 'wrap',
                gap: '15px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <IPCheckbox
                  name='Active'
                  label='Bankaya Göre Grupla'
                  checked={isBankGroup}
                  onCheckedChange={checked => setIsBankGroup(checked)}
                />
              </div>
              <button
                type='submit'
                style={{
                  background: 'linear-gradient(135deg, #dc3545, #c82333)',
                  color: 'white',
                  border: 'none',
                  padding: '15px 30px',
                  borderRadius: '10px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
                onClick={toggleBankNameColumn}
                onMouseEnter={e => {
                  const target = e.target as HTMLButtonElement
                  target.style.transform = 'translateY(-2px)'
                  target.style.boxShadow = '0 10px 20px rgba(220, 53, 69, 0.3)'
                }}
                onMouseLeave={e => {
                  const target = e.target as HTMLButtonElement
                  target.style.transform = 'translateY(0)'
                  target.style.boxShadow = 'none'
                }}
              >
                🔍 {t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.show')}
              </button>
            </div>
          </form>

          {/* Alert */}
          {state.reportList.PaymentTransactionLists && state.reportList.PaymentTransactionLists.length === 0 && (
            <div
              style={{
                background: '#fff3cd',
                border: '1px solid #ffeaa7',
                color: '#856404',
                padding: '15px',
                borderRadius: '8px',
                margin: '20px 30px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <span style={{ fontSize: '18px' }}>⚠️</span>
              <span>Veri bulunamadı.</span>
            </div>
          )}

          {/* Detaylı Süz Alanı */}
          {showFilterRow && (
            <div
              style={{
                background: '#f8f9fa',
                borderTop: '1px solid #e9ecef',
                padding: '30px',
                animation: 'slideDown 0.3s ease-out',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '25px',
                }}
              >
                <h2
                  style={{
                    color: '#495057',
                    fontSize: '1.8rem',
                    fontWeight: '600',
                    margin: 0,
                  }}
                >
                  Detaylı Süz
                </h2>
                <button
                  style={{
                    background: '#dc3545',
                    color: 'white',
                    border: 'none',
                    width: '35px',
                    height: '35px',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s ease',
                  }}
                  onClick={() => setShowFilterRow(false)}
                  onMouseEnter={e => {
                    const target = e.target as HTMLButtonElement
                    target.style.background = '#c82333'
                    target.style.transform = 'scale(1.1)'
                  }}
                  onMouseLeave={e => {
                    const target = e.target as HTMLButtonElement
                    target.style.background = '#dc3545'
                    target.style.transform = 'scale(1)'
                  }}
                >
                  ✕
                </button>
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                  gap: '20px',
                  marginBottom: '30px',
                }}
              >
                <div
                  style={{
                    background: 'white',
                    padding: '20px',
                    borderRadius: '12px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.2s ease',
                  }}
                >
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '10px',
                      fontWeight: '600',
                      color: '#495057',
                      fontSize: '14px',
                    }}
                  >
                    Kampanya Seçiniz...
                  </label>
                  <IPSelectBox
                    isClearable
                    isMulti
                    isCreatableSelect
                    isSearchable
                    placeholder='Kampanya Seçiniz...'
                    options={campaignSelectOptions}
                    value={campaignSelectOption}
                    onChangeMulti={option => {
                      setCampaignSelectOption(option)
                    }}
                  />
                </div>

                {isBankGroup && (
                  <div
                    style={{
                      background: 'white',
                      padding: '20px',
                      borderRadius: '12px',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <label
                      style={{
                        display: 'block',
                        marginBottom: '10px',
                        fontWeight: '600',
                        color: '#495057',
                        fontSize: '14px',
                      }}
                    >
                      Banka...
                    </label>
                    <IPSelectBox
                      isClearable
                      placeholder='Banka...'
                      options={bankSelectOptions}
                      value={bankSelectOption}
                      onChangeSingle={option => {
                        setBankSelectOption(option)
                      }}
                    />
                  </div>
                )}

                <div
                  style={{
                    background: 'white',
                    padding: '20px',
                    borderRadius: '12px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.2s ease',
                  }}
                >
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '10px',
                      fontWeight: '600',
                      color: '#495057',
                      fontSize: '14px',
                    }}
                  >
                    Şirket...
                  </label>
                  <IPSelectBox
                    isClearable
                    placeholder='Şirket...'
                    options={state.companyListOptions}
                    value={state.companyListOption}
                    onChangeSingle={option => {
                      setState({ companyListOption: option })
                    }}
                  />
                </div>

                <div
                  style={{
                    background: 'white',
                    padding: '20px',
                    borderRadius: '12px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.2s ease',
                  }}
                >
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '10px',
                      fontWeight: '600',
                      color: '#495057',
                      fontSize: '14px',
                    }}
                  >
                    Cari Kodu...
                  </label>
                  <IPInput
                    type='text'
                    id='Title'
                    name='Title'
                    placeholder='Cari Kodu...'
                    onChange={e => setDealerFilter(e.target.value)}
                    value={dealerFilter}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '14px',
                      transition: 'all 0.2s ease',
                      background: 'white',
                    }}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        filterList()
                      }
                    }}
                  />
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  gap: '20px',
                  justifyContent: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <button
                  type='button'
                  style={{
                    padding: '15px 30px',
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    minWidth: '200px',
                    background: 'linear-gradient(135deg, #ec1d25, #d41428)',
                    color: 'white',
                  }}
                  onClick={filterList}
                  onMouseEnter={e => {
                    const target = e.target as HTMLButtonElement
                    target.style.transform = 'translateY(-2px)'
                    target.style.boxShadow = '0 10px 20px rgba(236, 29, 37, 0.3)'
                  }}
                  onMouseLeave={e => {
                    const target = e.target as HTMLButtonElement
                    target.style.transform = 'translateY(0)'
                    target.style.boxShadow = 'none'
                  }}
                >
                  🔍 DETAYLI SÜZ
                </button>
                <button
                  type='button'
                  style={{
                    padding: '15px 30px',
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    minWidth: '200px',
                    background: 'linear-gradient(135deg, #28a745, #20c997)',
                    color: 'white',
                  }}
                  onClick={excelButton}
                  onMouseEnter={e => {
                    const target = e.target as HTMLButtonElement
                    target.style.transform = 'translateY(-2px)'
                    target.style.boxShadow = '0 10px 20px rgba(40, 167, 69, 0.3)'
                  }}
                  onMouseLeave={e => {
                    const target = e.target as HTMLButtonElement
                    target.style.transform = 'translateY(0)'
                    target.style.boxShadow = 'none'
                  }}
                >
                  📊 EXCEL'E AKTAR
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Table section remains the same */}
        {state.reportList.PaymentTransactionLists && state.reportList.PaymentTransactionLists.length > 0 && (
          <div style={{ padding: '30px' }}>
            <div
              style={{
                overflowX: 'auto',
                overflowY: 'auto',
                maxHeight: '55vh',
                borderRadius: '12px',
                border: '1px solid #e9ecef',
              }}
            >
              <table className={`table ${tableStyles}`} style={{ width: '100%', minWidth: '1200px' }} {...getTableProps()}>
                <thead>
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(column => (
                        // @ts-ignore
                        <th {...column.getHeaderProps(column.getSortByToggleProps())}>{column.render('Header')}</th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row, i) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map(cell => {
                          return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                        })}
                      </tr>
                    )
                  })}
                  {!isBankGroup && (
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>
                        <b>Toplam</b>
                      </td>
                      {totalFields.map((field, index) => (
                        <td key={index}>
                          <b>
                            {totalValues[index]
                              .toFixed(2)
                              .replace('.', ',')
                              .replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '₺'}
                          </b>
                        </td>
                      ))}
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className='mt-3'>
              <button
                className='btn btn-sm btn-secondary'
                onClick={() => {
                  gotoPage(0)
                  sessionStorage.setItem('Page', '0')
                }}
                disabled={!canPreviousPage}
              >
                {'<<'}
              </button>{' '}
              <button
                className='btn btn-sm btn-secondary'
                onClick={() => {
                  previousPage()
                  sessionStorage.setItem('Page', String(pageIndex - 1))
                }}
                disabled={!canPreviousPage}
              >
                {'<'}
              </button>{' '}
              <button
                className='btn btn-sm btn-secondary'
                onClick={() => {
                  nextPage()
                  sessionStorage.setItem('Page', String(pageIndex + 1))
                }}
                disabled={!canNextPage}
              >
                {'>'}
              </button>{' '}
              <button
                className='btn btn-sm btn-secondary'
                onClick={() => {
                  gotoPage(pageCount - 1)
                  sessionStorage.setItem('Page', String(pageCount - 1))
                }}
                disabled={!canNextPage}
              >
                {'>>'}
              </button>{' '}
              <span>
                Sayfa{' '}
                <strong>
                  {pageIndex + 1} / {pageOptions.length}
                </strong>{' '}
              </span>
              <span>
                | Sayfaya git:{' '}
                <input
                  type='number'
                  defaultValue={pageIndex + 1}
                  onChange={e => {
                    if (Number(e.target.value) < 0) return
                    const page = e.target.value ? Number(e.target.value) - 1 : 0
                    gotoPage(page)
                    sessionStorage.setItem('Page', String(page))
                  }}
                  style={{ width: 80 }}
                />
              </span>{' '}
              <select
                value={pageSize}
                onChange={e => {
                  setPageSize(Number(e.target.value))
                  sessionStorage.setItem('PageSize', String(e.target.value))
                }}
                style={{ width: 120 }}
              >
                {[10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize} Satır Göster
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
export default componentWithContext(BankInstallmentReport)
